export enum ShortCodeType {
    WhiteList = 1,
    BlackList = 2
}
